export default __webpack_public_path__ + "static/media/ryan-speaking.30a74bed.jpg";